// extracted by mini-css-extract-plugin
export default {"mobileBackButtonRow":"PanelHeader_mobileBackButtonRow__6CoUs","mobileBackButton":"PanelHeader_mobileBackButton__2N5eL"};